export enum YesNoBool {
  YES = "yes",
  NO = "no",
}

export enum DefaultFormValidationLimits {
  STRING_MAX = 50,
}
